const CountryPaymentVendors = {
    zw: "DSO"
}

export default CountryPaymentVendors;